import { Grid } from "@mui/material";
import { ClientModelInput, ModelScenarioOutput } from "@services/api/types";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { MetricCard } from "./MetricCard";

export interface KpiBudgetCardProps {
  outputs: ModelScenarioOutput[];
  budget: ClientModelInput[];
  timePeriods: string[];
  showBudget?: boolean;
}

const KpiBudgetCard = ({
  outputs,
  budget,
  timePeriods,
  showBudget = false
}: KpiBudgetCardProps) => {
  const { t } = useTranslation();

  const totalMetric = useMemo(() => {
    const inflowTotal = outputs.reduce((acc, elem) => elem.value + acc, 0);
    const budgetTotal = budget.reduce((acc, elem) => elem.value + acc, 0);

    const comparison =
      budgetTotal > 0 ? ((inflowTotal - budgetTotal) / budgetTotal) * 100 : 0;
    return (
      <MetricCard
        time_period={t("simulator.scenario.total")}
        kpi={inflowTotal}
        budget={budgetTotal}
        comparison={comparison}
        showBudget={showBudget}
      />
    );
  }, [t, outputs, budget]);

  const timePeriodMetrics = useMemo(() => {
    return timePeriods.map((timePeriod) => {
      const inflow =
        outputs.find((output) => output.time_period === timePeriod)?.value || 0;
      const budgetPeriod =
        budget.find((output) => output.time_period === timePeriod)?.value || 0;

      const comparison =
        budgetPeriod > 0 ? ((inflow - budgetPeriod) / budgetPeriod) * 100 : 0;
      return (
        <Grid
          size={{ xs: 12, sm: 12, md: 12 / outputs.length }}
          sx={{ justifyContent: "center" }}
          key={timePeriod}
        >
          <MetricCard
            time_period={timePeriod}
            kpi={inflow}
            budget={budgetPeriod}
            comparison={comparison}
            showBudget={showBudget}
          />
        </Grid>
      );
    });
  }, [outputs, budget, timePeriods]);

  return (
    <Grid container spacing={3} justifyContent="center" className="pb-4">
      <Grid size={{ xs: 12, sm: 12, md: 12 }} sx={{ justifyContent: "center" }}>
        {totalMetric}
      </Grid>
      <Grid size={{ xs: 12, sm: 12, md: 12 }} sx={{ justifyContent: "center" }}>
        <Grid container spacing={2} justifyContent="center">
          {timePeriodMetrics}
        </Grid>
      </Grid>
    </Grid>
  );
};
export default KpiBudgetCard;
